(function() {
	'use strict';

	angular.module('app.leanProjects')
		.service('assessmentService', assessmentService);

	function assessmentService($http, hostUrl, URLS, leanFilterService, excelExportService) {
		var urlPfx = '2/factndx/';
		var heightRowsChanged = [];
		return {
			getRatingsBySystemNameChartData: getRatingsBySystemNameChartData,
			getAssessmentsData: getAssessmentsData,
			updateAssessment: updateAssessment,
			alignContainers: alignContainers,
			getExcel: getExcel
		};

		function getExcel(modalScope) {
			var pageUrl = hostUrl + buildUrl('/Assessments?excelRequest=true');
			return excelExportService.getExcelReportWithGet(leanFilterService.getFactoryList(), pageUrl, modalScope);
		}

		function getRatingsBySystemNameChartData() {
			var pageUrl;
			pageUrl = buildUrl('/Assessments/RatingsBySystemName');
			return $http.get(hostUrl + pageUrl).then(function(result) {
				return result.data;
			});
		}

		function getAssessmentsData() {
			var pageUrl;
			pageUrl = buildUrl('/Assessments');
			return $http.get(hostUrl + pageUrl).then(function(result) {
				return result.data;
			});
		}

		function buildUrl(path) {
			var factories = leanFilterService.getFactoryList();
			var url = urlPfx + factories + path;
			var qParams = '';
			url = leanFilterService.addFilterQueryParams(url);
			return url;
		}

		function updateAssessment(siteId, assessment, lastModified) {
			var pageUrl = String.format(URLS.factoryAssessment, siteId);
			return $http.put(URLS.host + pageUrl + '/' + assessment.ndx, assessment, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateAssessmentSuccess, handleError);

			function updateAssessmentSuccess(response) {
				return response;
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}

		function alignContainers(gridContainer , grid) {
			var rows = angular.element(gridContainer + ' .ui-grid .ui-grid-render-container-body .ui-grid-row');
			var pinnedRowsLeft = angular.element(gridContainer + ' .ui-grid .ui-grid-pinned-container-left .ui-grid-row');
			var gridHasRightContainer = grid.hasRightContainer();
			if (gridHasRightContainer) {
				var pinnedRowsRight = angular.element(gridContainer + ' .ui-grid .ui-grid-pinned-container-right .ui-grid-row');
			}

			var bodyContainer = grid.renderContainers.body;

			// get count columns pinned on left
			var columnsPinnedOnLeft = grid.renderContainers.left.renderedColumns.length;

			for (var r = 0; r < heightRowsChanged.length; r++) {
				heightRowsChanged[r].height = 30;
			}
			heightRowsChanged = [];

			for(var r = 0; r < rows.length; r++) {
				// Remove height CSS property to get new height if container resized (slidePanel)
				var elementBody = angular.element(rows[r]).children('div');
				elementBody.css('height', '');
				var elementLeft = angular.element(pinnedRowsLeft[r]).children('div');
				elementLeft.css('height', '');
				if (gridHasRightContainer) {
					var elementRight = angular.element(pinnedRowsRight[r]).children('div');
					elementRight.css('height', '');
				}

				// GET Height when set in auto for each container
				// BODY CONTAINER
				var rowHeight = rows[r].offsetHeight;
				// LEFT CONTAINER
				var pinnedRowLeftHeight = 0;
				if (columnsPinnedOnLeft) {
					pinnedRowLeftHeight = pinnedRowsLeft[r].offsetHeight;
				}
				// RIGHT CONTAINER
				var pinnedRowRightHeight = 0;
				if (gridHasRightContainer) {
					pinnedRowRightHeight = pinnedRowsRight[r].offsetHeight;
				}
				// LARGEST
				var largest = Math.max(rowHeight, pinnedRowLeftHeight, pinnedRowRightHeight);

				// Apply new row height in each container
				elementBody.css('height', largest);
				elementLeft.css('height', largest);
				if (gridHasRightContainer) {
					elementRight.css('height', largest);
				}

				// Apply new height in gridRow definition (used by scroll)
				//bodyContainer.renderedRows[r].height = largest;
				var heightRowChanged = bodyContainer.renderedRows[r];
				heightRowChanged.height = largest;
				heightRowsChanged.push(heightRowChanged);
			}
			// NEED TO REFRESH CANVAS
			bodyContainer.canvasHeightShouldUpdate = true;
		};
	}
})();
